<div style="padding:30px; padding-bottom: 5px;">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item" (click)="choose(item.id)">
            <span style="cursor:pointer"  [ngClass]="tool_obj.action == item.id ? 'active' : ''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>
    <div *ngIf="act_type == 1">
        <app-date [time]="time" [type]="true" [timeset]="timeset" [limitset]="limitset" (rangeSelected)="handleRangeSelected($event)"></app-date>
        <select class="form-control"
            style="width: 160px;display: inline-block;margin: 10px;"
            [(ngModel)]="tool_obj.status"
            (change)="init_list()"
        >
            <option *ngFor="let item of status_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        共{{pageobj.total_count}}筆
    </div>
</div>

<div class="container-fuild" *ngIf="tool_obj.action === '2'">
    <div style="padding-left: 20px; padding-right: 20px;">
        <h3 class="font-weight-bold mb-4">📌 申請與通過比例</h3>
        <div class="mt-2">
            <!-- <highcharts-chart *ngIf="country_model=='all'" class="son_pie" [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions" ></highcharts-chart> -->
            <!-- 🔽 下拉選單來選擇員工 🔽 -->
            <div class="d-flex">
                <div *ngIf="loginEmployeePowerID == '5' || loginEmployeePowerID == '6' || loginEmployeePowerID == '13'" class="d-flex align-items-center gap-2 mb-3">
                    <span class="ml-2 mr-2">🔎 選擇員工：</span>
                    <select class="form-control w-auto" [(ngModel)]="selectedEmp" (change)="generateApprovalReport()">

                        <option value="-1">全部</option>
                        <option *ngFor="let emp of empList" [value]="emp.id">
                            {{ "姓名: " + emp.name }}
                        </option>

                    </select>
                </div>

                <div class="d-flex align-items-center gap-2 mb-3">
                     <!-- 日期查詢功能 -->
                    <span class="ml-4 pr-2 d-flex align-items-center"> 📆查詢日期範圍: </span>
                    <app-date [type]="true" [timeset]="timeset" [time]="adminReview_time"  (rangeSelected)="adminReviewHandleRangeSelected($event)" (showDatePickered)="adminReviewShowDatePickered()"></app-date>
                </div>
            </div>


            <div class="mb-3">
                <!-- 資料表 -->
                <app-table-v2 class="bg-white" [data]="employeeData" [tcontent]="reviewtcontent" [type]="2">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'create_dt'">
                            {{post.val.create_dt}}
                        </div>
                    </ng-template>
                </app-table-v2>
            </div>

            <div *ngIf="selectedEmp === '-1' && loginEmployeePowerID != '15'">
                <div class="row">
                    <!-- 申請件數比例 -->
                    <highcharts-chart class="son_pie col" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="pieOptions"></highcharts-chart>

                    <!-- 所有人申請狀態比例 -->
                    <highcharts-chart class="son_pie col" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="pieStatusOptions"></highcharts-chart>
                </div>
            </div>

            <div *ngIf="selectedEmp !== '-1' || loginEmployeePowerID == '15'">
                <!-- <span>123456789</span> -->
                <highcharts-chart class="son_pie" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="pieOptions"></highcharts-chart>
            </div>


              <!-- 分頁組件 -->
              <!-- <app-pagnation (callback)="firstDeposit_callback($event)" [data]="firstDepositPageStr"></app-pagnation> -->
        </div>
    </div>
</div>

<div *ngIf="tool_obj.action === '0' || tool_obj.action === '1'">
    <div style="padding: 43px;">
        <button [ngClass]="act_type==1?'btn-info':'btn-secondary'"  (click)="act_type=1" class="btn modalbtn" style="margin-right: 10px;">復權專區</button>
        <button [ngClass]="act_type==2?'btn-primary':'btn-secondary'"  (click)="act_type=2" class="btn modalbtn">審核專區</button>
    </div>

    <div *ngIf="act_type == 2">
        <div style="margin-left: 5%;">
            <i class="fa fa-star" aria-hidden="true" style="color: rgb(99, 36, 182);">取消</i>
            <i class="fa fa-star" aria-hidden="true" style="color: rgb(0, 0, 0);">拒絕</i>
            <i class="fa fa-star" aria-hidden="true" style="color: rgb(255, 102, 0);">待審</i>
            <i class="fa fa-star" aria-hidden="true" style="color: rgb(35, 168, 79);">通過</i>
            <i class="fa fa-star" aria-hidden="true" style="color: rgb(35, 130, 168);">暫時通過</i>
        </div>

        <app-calendar [schedules]="schedules"
            (onAddSchedule)="onAddSchedule($event)"
            (onViewAllSchedule)="onViewAllSchedule($event)"
            (onDeleteSchedule)="onDeleteSchedule($event)"
            (onViewSchedule)="onViewSchedule($event)"
            (dateChange)="onDateChange($event)">
        </app-calendar>

        <!-- Bootstrap 彈跳視窗 -->
        <ng-template #yourModalContent let-modal>
            <div class="modal-header">
                <h4 class="modal-title">審核列表</h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click');close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                排序:
                <select class="form-control"
                style="width: 160px;display: inline-block;margin: 10px;"
                [(ngModel)]="detail_status"
                (change)="sort_list()"
                >
                    <option *ngFor="let item of detail_list" [ngValue]="item.id">{{item.name}}</option>
                </select>

                <app-table-v2 [type]="1"  [data]="detialdata.data.data"  [tcontent]="tcontent2">
                    <ng-template let-post #operation_dk>
                        <div>
                            <div *ngIf="post.key == 'content'">

                                <div *ngIf="post.val.show_type == '4'">
                                    <video class="m-3"  src="{{post.val.content}}"  style="width:170px" controls *ngIf="post.val.show_type*1 == 4"></video>
                                </div>
                                <div *ngIf="post.val.show_type == '3'">
                                    <img loading="lazy" class="m-3"  [src]="post.val.content" style="width:170px" alt="不見了">
                                </div>
                                <div *ngIf="post.val.show_type == '2'">
                                    <video class="m-3"  src="{{post.val.content}}"  style="width:140px;height: 20px;" controls *ngIf="post.val.show_type*1 == 2"></video>
                                </div>
                                <div *ngIf="post.val.show_type == '1'">
                                    <ng-container *ngIf="post.val.content && post.val.content.substring(0, 4) === '復權用戶'">
                                        <div *ngFor="let item of post.val.front_show_info.front_show">
                                            <ng-container *ngIf="item.content && item.content.substring(0, 4) === '復權用戶'">
                                                <app-check-permissions [data]="'xEKH'">
                                                    <app-userandactive  [post]=" item.data"></app-userandactive>
                                                </app-check-permissions>
                                                <app-check-permissions [data]="'VbpG'">
                                                    {{post.val.content}}
                                                </app-check-permissions>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="post.val.content && post.val.content.substring(0, 4) != '復權用戶'">
                                        <h4>{{post.val.content}}</h4>
                                    </ng-container>
                                </div>
                            </div>
                            <div *ngIf="post.val.type == '異常通訊補鑽申請' && post.key == 'date' ">
                                --------
                            </div>
                            <div *ngIf="post.val.type != '異常通訊補鑽申請' && post.key == 'date' ">
                                {{post.val.date}}
                            </div>
                            <div *ngIf="post.key == 'lsstatus' && post.val.lsstatus == -2">
                                取消
                            </div>
                            <div *ngIf="post.key == 'lsstatus' && post.val.lsstatus == -1">
                                拒絕
                            </div>
                            <div *ngIf="post.key == 'lsstatus' && post.val.lsstatus == 0">
                                待審
                            </div>
                            <div *ngIf="post.key == 'lsstatus' && post.val.lsstatus == 1">
                                通過
                            </div>
                            <div *ngIf="post.key == 'lsstatus' && post.val.lsstatus == 2">
                                暫時通過
                            </div>
                            <div *ngIf="post.key == 'gg'">
                                <a *ngIf="post.key=='gg' && post.val.lsstatus != '-2'" style="cursor: pointer;" title="點我觀看" (click)="handleClick(post)"><i style="margin-right:10px" class="fas fa-list-ul"></i></a>
                                <a *ngIf="post.key=='gg' && (post.val.show_type == '2' || post.val.show_type == '3'|| post.val.show_type == '4')" style="cursor: pointer;" title="複製" (click)="copyToClipboard(post.val.content)"><i style="margin-right:10px" class="fa fa-copy"></i></a>
                            </div>
                        </div>
                    </ng-template>
                </app-table-v2>
            </div>
            <!-- <app-pagnation (callback)="callback3($event)" [data]="pageobjstr3"></app-pagnation>  -->
        </ng-template>
    </div>
    <div *ngIf="act_type == 1">
        <div *ngIf="data.length > 0">
            <app-table-v2 [type]="1"  [data]="data" [topData]="top_data" [tcontent]="tcontent"  (sortdata)="handlesortdata($event)">
                <ng-template let-post #operation_hd>
                    <div style="margin-left: 30px;max-width:100vw;width: 350px;" *ngIf="tool_obj.action*1==1">
                        <div class="accordion set_validate" id="accordionExample">
                            <div class="card">
                                <button class="btn btn-link btn-block text-left"
                                type="button" data-toggle="collapse" (click)="tool_obj.used_patch=!tool_obj.used_patch;used_patch()"
                                data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    批次處理
                                </button>
                            </div>
                            <div id="collapseOne"  class="collapse" aria-labelledby="headingOne" *ngIf="tool_obj.used_patch" data-parent="#accordionExample">
                                <div class="card-body">
                                    <textarea class="form-control" [(ngModel)]="tool_obj.patch_memo" style="width:400px;height: 120px;"></textarea>
                                    <select class="form-control"
                                    style="width: 160px;display: inline-block;margin: 10px;"
                                    [(ngModel)]="tool_obj.patch_status"
                                    >
                                        <option *ngFor="let item of patch_status_list" [ngValue]="item.id">{{item.name}}</option>
                                    </select>
                                    <button class="btn btn-primary" *ngIf="tool_obj.patch_status!=0" (click)="checkLt(post)">確定送出</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template let-post #operation_dk>
                    <div>
                        <div *ngIf="post.key == 'view'">
                            <div *ngIf="post.val.show_type == '4'">
                                <video class="m-3"  src="{{post.val.show_content}}"  style="width:170px" controls *ngIf="post.val.show_type*1 == 4"></video>
                            </div>
                            <div *ngIf="post.val.show_type == '3'">
                                <img loading="lazy" class="m-3"  [src]="post.val.show_content" style="width:170px" alt="不見了">
                            </div>
                            <div *ngIf="post.val.show_type == '2'">
                                <video class="m-3"  src="{{post.val.show_content}}"  style="width:140px;height: 20px;" controls *ngIf="post.val.show_type*1 == 2"></video>
                            </div>
                            <div *ngIf="post.val.show_type == '1'">
                                <ng-container *ngIf="post.val.show_content && post.val.show_content.substring(0, 4) === '復權用戶'">
                                    <div *ngFor="let item of post.val.front_show_info.front_show">
                                        <ng-container *ngIf="item.content && item.content.substring(0, 4) === '復權用戶'">
                                            <app-check-permissions [data]="'xEKH'">
                                                <app-userandactive  [post]=" item.data"></app-userandactive>
                                            </app-check-permissions>
                                            <app-check-permissions [data]="'VbpG'">
                                                {{post.val.show_content}}
                                            </app-check-permissions>
                                        </ng-container>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="post.val.show_content && post.val.show_content.substring(0, 4) != '復權用戶'">
                                    <h4>{{post.val.show_content}}</h4>
                                </ng-container>
                            </div>
                        </div>
                        <div *ngIf="post.key == 'start_dt'">
                            <div *ngFor="let item of post.val.front_show_info.front_show">
                                <ng-container *ngIf="item.content && item.content.substring(0, 2) === '時間'">
                                    {{ item.content.substring(3) }}
                                </ng-container>
                            </div>
                        </div>
                        <a *ngIf="post.key=='gg'" style="cursor: pointer;" title="點我觀看" (click)="handleClick(post)"><i style="margin-right:10px" class="fas fa-list-ul"></i></a>
                        <a *ngIf="post.key=='gg' && (post.val.show_type == '2' || post.val.show_type == '3'|| post.val.show_type == '4')" style="cursor: pointer;" title="複製" (click)="copyToClipboard(post.val.show_content)"><i style="margin-right:10px" class="fa fa-copy"></i></a>

                        <div *ngIf="post.key=='reason'" [innerHTML]="post.val.reason"></div>
                    </div>
                </ng-template>
            </app-table-v2>
            <!-- <app-table [type]="1" [data]="data"  (sortdata)="handlesortdata($event)" [custom]="custom" (link) = "handleClick($event)"></app-table> -->
        </div>
        <div style="width: 80%;">
            <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
        </div>
        <div style="margin: 10px;" *ngIf="data.length==0">無資料</div>
    </div>
</div>



<app-spinner [loading]="loading"></app-spinner>
<app-toast></app-toast>

<span  id="ggwp1" style="visibility: hidden;"  data-toggle="modal" data-target=".bd-example-modal-xl">
    <a href="javascript:void(0)">12332</a>
</span>

<div
    class="modal fade bd-example-modal-xl" tabindex="-1"
    role="dialog"  data-keyboard="false" data-backdrop="static"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
    *ngIf="review_show_data*1!=-1" style="z-index: 100000;"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <!-- 左邊標題 -->
                <h5 class="mb-0">
                    {{ tool_obj.action == 0 ? '我的申請紀錄' : '待審資料' }}
                </h5>

                <!-- 右邊：上鎖 + 金額 + 關閉 -->
                <div class="d-flex align-items-center" *ngIf="lockAmount_btn == 1">

                    <!-- 上鎖按鈕 -->
                    <button type="button" class="btn btn-sm btn-outline-secondary mr-2" (click)="toggleLockInput()">
                        <!-- 你有用 icon 可以換成 <i class="fa fa-lock"></i> 之類 -->
                        <span *ngIf="!showLockInput">上鎖</span>
                        <span *ngIf="showLockInput">取消上鎖</span>
                    </button>

                    <!-- 金額輸入框（只有上鎖時才顯示） -->
                    <input *ngIf="showLockInput"
                        type="number"
                        class="form-control form-control-sm mr-2"
                        placeholder="輸入金額"
                        [(ngModel)]="lockAmount"
                        style="width: 120px;"
                    >

                    <!-- 原本的關閉按鈕 -->
                    <button type="button" class="close" data-dismiss="modal" (click)="closemadel()">
                        &times;
                    </button>
                </div>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="dynamic-list" *ngFor="let item of review_show_data.front_show_info.front_show">
                    <div class="list-item">
                        <div style="margin: 10px;" *ngIf="item.type*1 == 3">
                            <h3>圖片</h3>
                            <img loading="lazy" class="" [src]="item.content" style="max-width:100%" alt="不見了">
                        </div>
                        <div style="margin: 10px;" *ngIf="item.type*1 == 5">
                            <h3>大頭照</h3>
                            <img loading="lazy" class="" [src]="item.content" style="max-width:100%" alt="不見了">
                        </div>
                        <div style="margin: 10px;" *ngIf="item.type*1 == 4">
                            <h3>影片</h3>
                            <video class="" [src]="item.content" style="max-width:100%" controls></video>
                        </div>
                        <div style="margin: 10px;" *ngIf="item.type*1 == 2">
                            <h3>語音</h3>
                            <video class="" [src]="item.content" style="max-width:100%; height: 50px;" controls></video>
                        </div>
                        <div class="description m-3" *ngIf="item.type*1 == 1">
                            <h4>{{ item.content }}</h4>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row" *ngIf="tool_obj.action==0 && tool_obj.status*1==0">
                    <div class="col-12 col-md-4 d-flex justify-content-center align-items-center mb-3 mb-md-0">
                        <button [ngClass]="review_show_data.status == 0 ? 'btn-danger':'btn-secondary'" (click)="review_show_data.status=0" class="btn modalbtn status">申請</button>
                        <button [ngClass]="review_show_data.status == -2 ? 'btn-danger':'btn-secondary'" (click)="review_show_data.status=-2" class="btn modalbtn status ml-2">取消</button>
                    </div>
                    
                    <div class="col-12 col-md-8">
                        <div class="d-flex flex-wrap align-items-center">
                            <h3 class="text-nowrap mr-3 mb-2 mb-md-0">審核留言</h3>
                            <textarea class="form-control flex-grow-1" [(ngModel)]="review_show_data.msg" style="width:400px;height: 120px;"disabled></textarea>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="tool_obj.action==1 && tool_obj.status*1==0">
                    <div class="col-12 col-md-4 d-flex justify-content-center align-items-center mb-3 mb-md-0">
                        <button [ngClass]="review_show_data.status==1?'btn-danger':'btn-secondary'" (click)="review_show_data.status=1" class="btn modalbtn status">同意</button>
                        <button [ngClass]="review_show_data.status==-1?'btn-danger':'btn-secondary'" (click)="review_show_data.status=-1" class="btn modalbtn status ml-2">拒絕</button>
                    </div>

                    <div class="col-12 col-md-8">
                        <div class="d-flex flex-wrap align-items-center">
                            <h3 class="text-nowrap mr-3 mb-2 mb-md-0">審核留言</h3>
                            <textarea class="form-control flex-grow-1" [(ngModel)]="review_show_data.msg" style="min-width:200px;height: 120px;"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="save(1)" *ngIf="review_show_data.status!=0" data-dismiss="modal">確認</button>
                <button type="button" class="btn btn-secondary" (click)="cancel()" data-dismiss="modal">關閉</button>
            </div>
        </div>
    </div>
</div>
